import { Link as ChakraLink } from '@chakra-ui/react'
import { LinkComponent, createLink } from '@tanstack/react-router'

const CreatedLink = createLink(ChakraLink)

export const Link: LinkComponent<typeof CreatedLink> = (props) => {
  return <CreatedLink {...props}>{props.children}</CreatedLink>
}
